function getImageLink (baseUrl, size = '@1', format = 'png') {
  const lastDotIndex = baseUrl.lastIndexOf(".")
  let imageLink = baseUrl.substring(lastDotIndex, 0)

  return `${imageLink}${size}.${format}`
}

export default getImageLink
